module.exports = __webpack_public_path__ + "static/media/IMG_1166.a56f9ce0.jpg";